<template>
  <v-chip
    class="px-2 ml-1"
    label
    size="x-small"
    variant="outlined"
    color="red"
  >
    必須
  </v-chip>
</template>

<script setup lang="ts">
</script>
